// check is desktop
window.isDesktop = () => {
  // check user agent aswell
  return !/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)
}

// Check is mobile
window.isMobile = () => {
  return !window.isDesktop()
}

$(document).ready(function() {
  // detect is desktop or mobile
  document.querySelectorAll('.is-mobile').forEach(el => {
    if (window.isMobile()) {
      el.classList.remove('d-none')
    } else {
      el.classList.add('d-none')
    }
  })

  document.querySelectorAll('.is-desktop').forEach(el => {
    if (window.isDesktop()) {
      el.classList.remove('d-none')
    } else {
      el.classList.add('d-none')
    }
  })

  // collapsible text
  document.querySelectorAll('.text-collapsible').forEach(el => {
    const content = el.querySelector('.text-collapsible-content')
    const trigger = el.querySelector('.trigger-button')
    const showText = el.getAttribute('data-text-show')
    const hideText = el.getAttribute('data-text-hide')
    const maxHeight = el.getAttribute('data-max-height') || '100px'
    const heightInt = parseInt(maxHeight.replace('px', ''))

    if (content.clientHeight < heightInt) {
      trigger.style.display = 'none'
      return 0
    }

    // break
    content.style.maxHeight = maxHeight

    trigger.addEventListener('click', () => {
      if (content.style.maxHeight) {
        content.style.maxHeight = null
        trigger.innerHTML = hideText
      } else {
        content.style.maxHeight = maxHeight
        trigger.innerHTML = showText
      }
    })
  })

  // Filter action
  const targetCustom = document.querySelector('.custom-date-input')
  document.querySelectorAll('.form-filter-popup').forEach(el => {
    el.addEventListener('change', e => {
      if (e.target.value == 'custom') {
        targetCustom.classList.remove('d-none')
      } else {
        targetCustom.classList.add('d-none')
      }
    })
  })

  // Redirect pages
  var redirectPage = document.querySelector('.redirect-page')
  if (redirectPage != null) {
    redirectPage.addEventListener('click', element => {
      var href = element.currentTarget.dataset['href'] || '#'
      window.location.replace(href)
    })
  }

  // backward url
  var metaBackwardUrl = document.querySelector('meta[name="backward-url"]');
  var hrefBackwardUrl = document.querySelector('#backward-url')
  if (metaBackwardUrl != null) {
    var backwardUrl = metaBackwardUrl.getAttribute('backward-url')

    if (hrefBackwardUrl != null) {
      if (backwardUrl.length > 0) {
        hrefBackwardUrl.href = backwardUrl
      }
    }
  }
})

// // Scroll and watch to header
// const watchScroll = () => {
//   console.log('SC')
// }

// window.addEventListener('scroll', () => {
//   watchScroll()
// })

// window.addEventListener('load', function() {
//   watchScroll()
// })